<template>

    <b-row>

        <b-col col lg="1" cols="1">
            <div  class="my-team-tree__level"
                  v-if="levelIndex > 0">
                <p>Level {{ levelIndex }}</p>
            </div>
        </b-col>

        <b-col col lg="11" cols="10">
            <div class="my-team-tree__carousel">
                <div class="my-team-tree__carousel__controls"
                     v-if="controlsVisible">
                    <div class="my-team-tree__carousel__controls__prev"
                         v-on:click="CarouselScrollPrev()">&lt;</div>
                    <div class="my-team-tree__carousel__controls__next"
                         v-on:click="CarouselScrollNext()">&gt;</div>
                </div>
                <div class="my-team-tree__carousel__wrapper"
                     v-touch:swipe.left="CarouselScrollNext"
                     v-touch:swipe.right="CarouselScrollPrev">
                    <div class="my-team-tree__carousel__wrapper__no-results"
                         v-if="!items.length">
                        No results
                    </div>
                    <div class="my-team-tree__carousel__wrapper__container"
                         :style="[getCarouselWidth, setPosition]"
                         v-bind:class="{ 'animation-available': isLoaded }"
                         v-if="items.length">
                        <div v-for="(item, index) in items"
                             v-bind:class="{
                                'active' : isElementActive === item.login || levelIndex === 0,
                                'inactive' : (isElementActive !== item.login && isElementSelected && levelIndex > 0),
                                'detailed': isDetailed === item.login }"
                             class="my-team-tree__carousel__wrapper__container__element"
                             :style="[getElementWidth]">
                            <div class="my-team-tree__carousel__wrapper__container__element__data"
                                 v-on:click="LoadNextLevel(item, index, levelIndex, $event)">
                                <span>{{ item.login }}</span>
                                <a class="my-team-tree__carousel__wrapper__container__element__data__email mdi mdi-email"
                                   v-if="isDetailed === item.login"
                                   :title="item.email"
                                   v-tippy="{ placement : 'bottom',  arrow: true }"
                                   :href="'mailto:' + item.email"></a>
                            </div>
                            <div class="my-team-tree__carousel__wrapper__container__element__connector">
                                <div class="my-team-tree__carousel__wrapper__container__element__connector__horizontal"></div>
                            </div>
                            <div class="my-team-tree__carousel__wrapper__container__element__circle"></div>
                            <div class="my-team-tree__carousel__wrapper__container__element__handler">
                                <div class="my-team-tree__carousel__wrapper__container__element__handler__holder"
                                     v-on:click="LoadNextLevel(item, index, levelIndex, $event)"></div>
                                <div class="my-team-tree__carousel__wrapper__container__element__handler__coin"
                                     v-if="levelIndex > 0">
                                    <img v-bind:src="GetCoinPath(item.career_level)">
                                </div>
                                <div class="my-team-tree__carousel__wrapper__container__element__handler__counts"
                                     v-if="levelIndex > 0">{{ item.children_count }}</div>
                                <div class="my-team-tree__carousel__wrapper__container__element__handler__button"
                                     v-on:click="ShowDetails(item)"
                                     v-if="levelIndex === 1">
                                    <div v-if="isDetailed === item.login" class="my-team-tree__carousel__wrapper__container__element__handler__button--close">x</div>
                                    <div v-if="isDetailed !== item.login">show details</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-col>
    </b-row>

</template>

<script>
    export default {
        dependencies: ['api', 'user'],
        props: ['items', 'levelIndex', 'index'],
        data () {
            return {
                config: {
                    elementWidth: 150,
                    elementsVisible: {
                        desktop: 5,
                        mobile: 1
                    }
                },
                carousel: {
                    container: 0,
                    wrapper: 0,
                    offset: 0,
                    active: -1,
                    loaded: false,
                    detailed: [-1, -1]
                }
            }
        },
        mounted: function() {
            // Get first row after 'me'
            if(this.levelIndex === 0){
                this.LoadNextLevel();
            }

            // Set initial row center
            let _container = this.$el.querySelector('.my-team-tree__carousel__wrapper__container');
            let _wrapper = this.$el.querySelector('.my-team-tree__carousel__wrapper');

            this.carousel.container = _container ? _container.offsetWidth : null;
            this.carousel.wrapper = _wrapper ? _wrapper.offsetWidth : null;
            let _this = this;

            // Add information in next digest to prevent problem with animation at the first stage
            // 333ms was set into CSS animations
            setTimeout(() => {
                _this.carousel.loaded = true;
            }, 333);

            // Simulate a set item as active when loading whole tree
            let _index = this.$store.getters.getTreePath[this.levelIndex + 1];
            let _tree = this.$store.getters.getTree[this.levelIndex];
            if(_index) {
                let _numberOfItems = _tree.length;
                let _median = parseInt(_numberOfItems / 2);
                this.carousel.active = JSON.parse(JSON.stringify(_index)).index;

                if(this.carousel.active > -1) {
                    this.carousel.offset = this.carousel.active - _median;
                    this.setPosition;
                }
            }

        },
        computed: {
            getElementWidth: function() {
                return {
                    width: this.config.elementWidth + 'px'
                }
            },

            getCarouselWidth: function() {
                return {
                    width: this.items.length * this.config.elementWidth + 'px'
                }
            },

            getCurrentUserLevel: function() {
                return this.$store.getters.getTree[0][0];
            },

            getActiveUser: function() {
                return this.$store.getters.getTreePath[this.levelIndex + 1]
            },

            controlsVisible: function() {
                return this.items.length > this.config.elementsVisible.desktop;
            },

            isElementActive: function() {
                return this.$store.getters.getTreePath[this.levelIndex + 1] ? this.getActiveUser.login : false;
            },

            isElementSelected: function() {
                return this.$store.getters.getTreePath[this.levelIndex + 1];
            },

            isLoaded: function() {
                return this.carousel.loaded;
            },

            setPosition: function() {

                // Different placement for even and odd circles
                let _isOdd = this.items.length % 2 === 1;
                let _valueToMove = _isOdd ? 0 : 0.5 * this.config.elementWidth;

                return {
                    transform: 'translate(' + (((this.carousel.wrapper - this.carousel.container) / 2) - (this.carousel.offset * this.config.elementWidth) - _valueToMove) + 'px, 0)'
                }
            },

            isDetailed: function() {
                return this.carousel.detailed;
            }
        },
        methods: {

            CarouselScrollPrev: function() {
                if(Math.abs(this.carousel.offset) < parseInt(this.items.length / 2) || this.carousel.offset === Math.abs(parseInt(this.items.length / 2))) {
                    this.carousel.offset--;
                    this.setPosition;
                }
            },

            CarouselScrollNext: function() {
                if(Math.abs(this.carousel.offset) < parseInt(this.items.length / 2) || this.carousel.offset === -Math.abs(parseInt(this.items.length / 2))) {
                    this.carousel.offset++;
                    this.setPosition;
                }
            },

            LoadNextLevel: function(item, index, levelIndex, event) {

                // Do not load if level 0 clicked
                if(levelIndex === 0) {
                    return;
                }

                // Do not load if user click on email icon
                if(event) {
                    // There is different object for MouseEvent in different browsers
                    // Chrome implementation
                    if(event.srcElement && event.srcElement.href) {
                        return;
                    } else

                    // Firefox implementation
                    if(event.originalTarget && event.originalTarget.href) {
                        return;
                    }

                }

                // Show spinner
                this.$store.commit('ShowTreeLoader', { loading: true });

                if(this.$store.getters.getTree[this.levelIndex + 1] && this.levelIndex > 0) {
                    this.$store.commit('BackToLevel', { levelIndex: this.levelIndex + 1 });
                }

                // Set offset to move carousel to valid position only if there is no 0 level
                if(this.levelIndex !== 0) {
                    this.carousel.offset = index - parseInt(this.items.length / 2);
                }

                // If item is not defined
                // Get it from stored array
                if(!item) {
                    // if no item provided, load logged user first level
                    item = this.getCurrentUserLevel
                }

                // Get data
                this.$http.get(this.api.user.tree.frontliners(item.login))
                    .then((frontliners) => {

                        // In edge cases check if item exist before increase path array
                        if(frontliners) {
                            this.$store.commit('SetPath', { login: item.login, index: index, levelIndex: this.levelIndex });

                            // Set clicked element to active
                            this.carousel.active = this.getActiveUser.index;
                        }

                        // Insert level at the bottom of array
                        this.$store.commit('InsertLevel', { level: frontliners.data.data, levelIndex: this.levelIndex });

                        // Hide spinner
                        this.$store.commit('ShowTreeLoader', { loading: false });

                    })

            },

            ShowDetails: function(item) {
                this.carousel.detailed = this.carousel.detailed === item.login ? null : item.login;
            },

            GetCoinPath: function(carrerLevel) {
                return 'static/img/coins/' + carrerLevel + '.png';
            }

        }
    }
</script>

<style lang="scss">

    @import '../../../../../../../assets/scss/_colors.scss';

    .my-team-tree {
        &__level p {
            transform: rotate(-90deg);
            white-space: nowrap;
            transform-origin: 155% 245%;
        }
        &__level {
            &:first-child {
                .my-team-tree__carousel__wrapper__container__element {
                    &:before {
                        display: none;
                    }
                }
                .my-team-tree__carousel__wrapper__container__element__circle {
                    transform: scale(1) !important;
                }
            }
        }
        &__carousel {
            position: relative;
            height: 180px;
            &:before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                height: 180px;
                width: 20px;
                background: linear-gradient(to right, rgba(255,255,255,1) 0%,rgba(255,255,255,0.99) 0%,rgba(255,255,255,0) 100%);
                z-index: 10;
            }
            &:after {
                content: '';
                position: absolute;
                right: 0;
                top: 0;
                height: 180px;
                width: 20px;
                background: linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(255,255,255,0.99) 100%,rgba(255,255,255,1) 101%);
                z-index: 10;
            }
            &__controls {
                transform: scale(1, 4);
                position: absolute;
                width: 106%;
                left: -3%;
                top: 45px;
                & > div {
                    position: absolute;
                    cursor: pointer;
                    user-select: none;
                }
                &__next {
                    right: 0;
                }
                &__prev {
                    left: 0;
                }
            }

            &__wrapper {
                overflow: hidden;
                &__container {
                    &.animation-available {
                        transition: .333s ease-in-out;
                    }
                    &__element {
                        padding: 30px 15px;
                        display: inline-block;
                        position: relative;
                        transition: .333s ease-in-out;
                        box-sizing: border-box;
                        &.inactive {
                            opacity: 0.2;
                            .my-team-tree__carousel__wrapper__container__element__circle,
                            .my-team-tree__carousel__wrapper__container__element__connector:before {
                                background: $d-gray;
                            }
                            .my-team-tree__carousel__wrapper__container__element__circle {
                                transform: scale(0.8);
                                &:hover {
                                    background: $base1;
                                }
                            }
                            &:before {
                                background: $d-gray;
                            }
                        }
                        &.active {
                            opacity: 1;
                            .my-team-tree__carousel__wrapper__container__element__circle {
                                transform: scale(1.2);
                            }
                            .my-team-tree__carousel__wrapper__container__element__data {
                                font-size: 16px;
                            }
                            .my-team-tree__carousel__wrapper__container__element__circle,
                            .my-team-tree__carousel__wrapper__container__element__connector:before,
                            .my-team-tree__carousel__wrapper__container__element__connector:after {
                                background: $op;
                            }
                            .my-team-tree__carousel__wrapper__container__element__connector:before,
                            .my-team-tree__carousel__wrapper__container__element__connector:after {
                                width: 2px;
                            }
                            .my-team-tree__carousel__wrapper__container__element__connector__horizontal {
                                position: absolute;
                                top: 0;
                                height: 2px;
                                background: $op;
                            }
                            &:before {
                                opacity: 0.2;
                                background: $d-gray;
                            }
                        }
                        &.detailed {
                            .my-team-tree__carousel__wrapper__container__element__circle {
                                transform: scale(1.35);
                                background: $op;
                            }
                            .my-team-tree__carousel__wrapper__container__element__data {
                                font-size: 18px;
                            }
                            .my-team-tree__carousel__wrapper__container__element__handler {
                                transform: rotate(-45deg);
                                width: 170px;
                                height: 170px;
                            }
                            .my-team-tree__carousel__wrapper__container__element__handler__button,
                            .my-team-tree__carousel__wrapper__container__element__handler__counts {
                                transform: rotate(45deg) scale(0.7);;
                            }
                            .my-team-tree__carousel__wrapper__container__element__handler__counts {
                                line-height: 50px;
                            }
                            .my-team-tree__carousel__wrapper__container__element__handler__coin {
                                width: 0;
                                height: 0;
                                opacity: 0;
                            }
                        }
                        &:before {
                            content: '';
                            width: 100%;
                            position: absolute;
                            height: 1px;
                            background: $base1;
                            top: 0;
                            left: 0;
                        }
                        &:first-child {
                            &:before {
                                width: 50%;
                                left: 50%;
                            }
                        }
                        &:last-child {
                            &:before {
                                width: 50%;
                                left: 0;
                            }
                        }
                        &:only-child {
                            &:before {
                                width: 0;
                            }
                        }
                        &__circle {
                            width: 120px;
                            height: 120px;
                            background-color: $base1;
                            transition: all 333ms ease-out;
                            border-radius: 100px;
                            border: 5px solid $white;
                            position: relative;
                            cursor: pointer;
                        }
                        &__handler {
                            position: absolute;
                            top: 30px;
                            left: 15px;
                            width: 120px;
                            height: 120px;
                            transform: rotate(45deg);
                            transition: all 333ms ease-out;
                            text-align: center;
                            color: $white;
                            &__holder {
                                width: 120px;
                                height: 120px;
                                position: absolute;
                                top: 0;
                                left: 0;
                                cursor: pointer;
                            }
                            &__counts {
                                width: 60px;
                                height: 60px;
                                background: $op;
                                border-radius: 30px;
                                border: 5px solid #ffffff;
                                transform: rotate(-45deg);
                                position: absolute;
                                top: 20px;
                                left: -30px;
                                font-size: 11px;
                                text-align: center;
                                line-height: 48px;
                                cursor: default;
                                z-index: 1;
                                transition: all 333ms ease-out;
                            }
                            &__button {
                                width: 60px;
                                height: 60px;
                                background: $op;
                                border-radius: 30px;
                                border: 5px solid #ffffff;
                                transform: rotate(-45deg);
                                position: absolute;
                                top: 20px;
                                right: -30px;
                                font-size: 11px;
                                text-align: center;
                                line-height: 13px;
                                padding: 10px 0;
                                z-index: 1;
                                transition: all 333ms ease-out;
                                cursor: pointer;
                                &--close {
                                    font-size: 20px;
                                    line-height: 23px;
                                }
                            }
                            &__coin {
                                width: 60px;
                                height: 60px;
                                border-radius: 30px;
                                border: 5px solid #ffffff;
                                transform: rotate(-45deg);
                                position: absolute;
                                top: -30px;
                                left: 20px;
                                z-index: 1;
                                transition: all 333ms ease-out;
                            }
                        }
                        &__details {
                            display: none;
                            opacity: 0;
                        }
                        &__connector {
                            &:before {
                                content: '';
                                width: 1px;
                                height: 90px;
                                position: absolute;
                                top: 0;
                                left: 50%;
                                background: $base1;
                            }
                            &:after {
                                content: '';
                                width: 1px;
                                height: 90px;
                                position: absolute;
                                bottom: 0;
                                left: 50%;
                            }
                        }
                        &__data {
                            position: absolute;
                            top: 50%;
                            transform: translate(-50%, -50%);
                            left: 50%;
                            z-index: 1;
                            text-align: center;
                            color: $white;
                            cursor: pointer;
                            &__email {
                                color: $white;
                                &:hover {
                                    color: $white;
                                }
                            }
                        }
                    }
                }
                &__no-results {
                    padding: 79px 0;
                    text-align: center;
                }
            }


        }
    }

    @media (max-width: 768px) {
        .my-team-tree__carousel__controls {
            display: none;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/my-team/my-team-tree-level/MyTeamTreeLevel.vue